//Contact-Page
export const contactInformationFormInput = {
    mb: 1,
}

export const width20P = {
    width: '20%',
}
export const width50P = {
    width: '50%'
}
export const width75P = {
    width: '75%'
}
export const width100P = {
    width: '100%'
}
